<template>
  <div >
    <new-payment-method-select @input="setAccountType"/>
    <div v-if="accountTypeSelected">
      <div v-if="isCard && card_details_valid">
        <span>Card ending in {{ form_data.card_details.last_four }}</span>
        <button class="btn btn-outline-secondary" @click="show_paya_modal = true">Change</button>
      </div>
      <transition v-on:enter="scrolldown('new-bank-account-form-pm')">
        <div v-if="!isCard && !show_paya_modal" id="new-bank-account-form-pm">
          <new-bank-account-form @input="(x) => form_data.bank_details = x" :account-name="accountName" @form-state="(x) => bank_details_valid = x"/>
        </div>
      </transition>
      <transition v-on:enter="scrolldown('new-payment-type-form-pm')">
        <div v-if="paymentAccountFormValid" id="new-payment-type-form-pm">
          <new-payment-type-form @input="setPaymentAccountType" @form-state="(x) => payment_type_valid = x" :show-billing-address="true" :first-name="initValues.fname" :last-name="initValues.lname" :formatted-address="initValues.formatted_address"/>
        </div>
      </transition>
    </div>
    <new-paya-payment-account-modal v-model="show_paya_modal" id="new-paya-payment-account-modal-ssu" @card-added="cardAdded" :account-name="accountName"/>
  </div>
</template>

<script>
  import NewBankAccountForm from "../NewBankAccountForm.vue";
  import NewPaymentMethodSelect from "../NewPaymentMethodSelect.vue";
  import NewPayaPaymentAccountModal from "../Modals/NewPayaPaymentAccountModal.vue";
  import { VBModal } from "bootstrap-vue";
  import NewPaymentTypeForm from "../NewPaymentTypeForm.vue";
  import helpers from "../../lib/helpers";

  export default {
    data () {
      return {
        scrolldown: helpers.scrolldown,
        show_paya_modal: false,
        card_details_valid: false,
        bank_details_valid: false,
        payment_type_valid: false,
        form_data: {
          alternate_billing_address: null,
          auto_pay: true,
          account_type: '',
          card_details: {
            internal_token: '',
            token: '',
            fname: '',
            lname: '',
            exp_month: 0,
            exp_year: 0,
            last_four: '',
            brand: '',
          },
          bank_details: {
            name: '',
            routing: '',
            account: '',
            account_type: ''
          },
          billing_address: {
            line1: '',
            line2: '',
            city: '',
            state: '',
            zip_code: '',
            zip_ext: '',
            fname: '',
            lname: '',
            mnami: '',
            cmp_name: ''
          },
        }
      }
    },

    props : {
      initValues: {
        required: false,
      },
    },

    mounted() {
      this.resetForm();
    },

    computed: {
      accountTypeSelected() {
        return !!this.form_data.account_type;
      },
      isCard () {
        return this.form_data.account_type === 'CREDIT_CARD';
      },
      modalTitle () {
        return 'Add payment method'
      },
      accountName () {
        if (this.initValues) {
          return `${this.initValues.fname || ''} ${this.initValues.lname || ''}`.trim();
        }
        return '';
      },
      paymentAccountFormValid () {
        return (this.isCard && this.card_details_valid) || (!this.isCard && this.bank_details_valid);
      },
      formDataValid () {
        if (!this.accountTypeSelected) {
          return false;
        }
        if (!this.paymentAccountFormValid) {
          return false;
        }
        return this.payment_type_valid;
      },
      formData () {
        return this.form_data;
      }
    },

    methods: {
      setAccountType (account_type) {
        this.form_data.account_type = account_type;
        if (account_type === 'ACH') {
          this.show_paya_modal = false;
        }
        if (!this.card_details_valid) {
          this.show_paya_modal = account_type === 'CREDIT_CARD';
        }
      },
      cardAdded (card_details) {
        this.card_details_valid = true;
        this.form_data.card_details = card_details;
      },
      setPaymentAccountType(data) {
        this.form_data.alternate_billing_address = data.alternate_billing_address
        this.form_data.auto_pay = data.auto_pay;
        this.form_data.billing_address = data.billing_address;
      },
      resetForm() {
        this.card_details_valid = false;
        this.bank_details_valid = false;
        this.payment_account_valid = false;
        this.form_data = {
          alternate_billing_address: null,
          auto_pay: true,
          account_type: '',
          card_details: {
            internal_token: '',
            token: '',
            fname: '',
            lname: '',
            exp_month: 0,
            exp_year: 0,
            last_four: '',
            brand: '',
          },
          bank_details: {
            name: '',
            routing: '',
            account: '',
            account_type: ''
          },
          billing_address: {
            line1: '',
            line2: '',
            city: '',
            state: '',
            zip_code: '',
            zip_ext: '',
            fname: '',
            lname: '',
            mnami: '',
            cmp_name: ''
          }
        };
      },
    },

    watch: {
      formData: {
        handler(new_val) {
          this.$emit('input', new_val);
        },
        deep: true
      },
      formDataValid(new_val){
        this.$emit('form-state', new_val);
        this.$emit(new_val ? 'form-valid' : 'form-invalid');
      },
    },

    components: {
      NewPaymentTypeForm,
      NewBankAccountForm,
      NewPaymentMethodSelect,
      NewPayaPaymentAccountModal
    },

    directives : {
      'b-modal': VBModal
    }
  }
</script>



// WEBPACK FOOTER //
// PaymentMethod.vue?909d1982